<template>
  <div>
    <el-row>

      <el-col :span="24" class="mb-2">
        <el-card shadow="never">
          <el-row>
            <el-col :span="12" :lg="8">
              <el-button round type="warning" icon="el-icon-plus" @click="showEditDialog()">
                新增店家收款帳戶
              </el-button>
            </el-col>

            <el-col :span="1" :lg="8"></el-col>

            <!-- <el-col :span="11" :lg="8">
              <el-form :inline="true" label-position="left" label-width="80px" @submit.native.prevent>
                <el-form-item label="搜尋店家">
                  <el-input v-model="queryParams.search" placeholder="（ID或關鍵字）" @change="updateSearch"></el-input>
                </el-form-item>
              </el-form>
            </el-col> -->
          </el-row>
        </el-card>
      </el-col>

      <!-- List of bank account / settings -->
      <el-col :span="24">

        <!-- <data-table :data="beneficiaries"
          :cols="cols" :total="total" :loading="isLoading"
          :on-sort-change="onSortChange" :on-page-request="onPageRequest"
          :rows-per-page-options="[10, 20, 30]" :on-rows-per-page-change="onRowsPerPageChange">

          <div slot="Bank" slot-scope="{row}">
            {{ row.bank_id }} {{ row.bank_name }}
          </div>

          <div slot="Actions" slot-scope="{row}">
            <el-button type="warning" icon="el-icon-edit" circle size="small" @click="showEditDialog(row)"></el-button>
          </div>
        </data-table> -->
        <SSRTable ref="list-beneficiaries" :data-url="urlBeneficiaries" :schema="cols" data-key="beneficiaries"
          :search-on="['account_id', 'shop_name', 'recipient_id', 'account_name', 'account_no']">
          <div slot="bank_id" slot-scope="{row}">
            {{ row.bank_id }} {{ row.bank_name }}
          </div>
          <div slot="actions" slot-scope="{row}">
            <el-button type="warning" icon="el-icon-edit" circle size="small" @click="showEditDialog(row)"></el-button>
          </div>
        </SSRTable>
      </el-col>

    </el-row>

    <!-- Dialog - Create/Update/Delete a beneficiary -->
    <el-dialog :visible.sync="dialog.crud.show" width="60%"
      :title="dialog.crud.mode == 'create'? '新增店家收款帳戶': '修改店家收款帳戶'">

      <el-form ref="form-bank-account" label-position="right" label-width="160px"
        :rules="dialog.crud.rules" :model="dialog.crud.model">
        <el-form-item label="店家" prop="shopId">
          <el-select filterable v-model="dialog.crud.model.shopId" :disabled="dialog.crud.mode != 'create'"
            placeholder="（輸入店名或ID以查找）">
            <el-option v-for="shop in shops" :key="shop.id"
              :label="`${shop.id} - ${shop.name}`" :value="shop.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款行（總行）" prop="bank">
          <el-autocomplete v-model="dialog.crud.model.bank"
            :fetch-suggestions="searchBank" placeholder="（輸入銀行名或代碼以查找）">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="收款人ID／統編" prop="recipientId">
          <el-input v-model="dialog.crud.model.recipientId">
          </el-input>
        </el-form-item>
        <el-form-item label="收款人戶名" prop="accountName">
          <el-input v-model="dialog.crud.model.accountName">
          </el-input>
        </el-form-item>
        <el-form-item label="收款人帳號" prop="accountNo">
          <el-input v-model="dialog.crud.model.accountNo">
          </el-input>
        </el-form-item>
        <!-- Form actions -->
        <el-form-item>
          <el-button type="primary" @click="createBeneficiary"
            v-if="dialog.crud.mode == 'create'" :disabled="dialog.crud.isLoading">新增
          </el-button>
          <el-button type="danger" @click="deleteBeneficairy"
            v-if="dialog.crud.mode == 'update'" :disabled="dialog.crud.isLoading">刪除
          </el-button>
          <el-button type="primary" @click="updateBeneficiary"
            v-if="dialog.crud.mode == 'update'" :disabled="dialog.crud.isLoading">更新
          </el-button>
          <progress v-show="dialog.crud.isLoading"></progress>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Progress } from 'src/components';
// import DataTable from 'src/components/DataTable';
import SSRTable from 'src/components/SSRTable';

import axios from 'axios';

export default {
  components: {
    [Progress.name]: Progress,
    // DataTable,
    SSRTable
  },

  mounted() {

    this.fetchBanks();
    this.fetchShops();
  },

  methods: {
    
    fetchBanks() {
      axios.get(`${process.env.VUE_APP_APIHOST}/gaa/acct/banks`)
      .then(response => {
        // this.banks = response.data.map(bank => `${bank['bank_id']} - ${bank['bank_name']}`);
        this.banks = response.data;
        console.log(`[BANK ACCOUNT] Obtained list of banks`, this.banks);
      })
      .catch(err => {
        console.error(`[BANK ACCOUNT] Cannot fetch bank list`, err);
        this.$notify.error({
          title: '查詢錯誤 - 銀行列表',
          message: err.data.message
        });
      });
    },
    fetchShops() {
      axios.get(`${process.env.VUE_APP_APIHOST}/gaa/shops`)
      .then(response => {
        this.shops = response.data;
      })
      .catch(err => {
        console.error(`[BANK ACCOUNT] Cannot fetch shop list`, err);
        this.$notify.error({
          title: '查詢錯誤 - 店家',
          message: err.data.message
        });
      });
    },

    showEditDialog(beneficiary) {
      // if (this.$refs['form-bank-account'])
      //   this.$refs['form-bank-account'].validate(valid => {  });

      if (beneficiary) {
        this.dialog.crud.mode = 'update';
        this.dialog.crud.shopId = beneficiary['account_id'];
        this.dialog.crud.model = {
          shopId: beneficiary['account_id'],
          bank: `${beneficiary['bank_id']} - ${beneficiary['bank_name']}`,
          recipientId: beneficiary['recipient_id'],
          accountName: beneficiary['account_name'], accountNo: beneficiary['account_no']
        };
      }
      else {
        this.dialog.crud.mode = 'create';
        this.dialog.crud.shopId = 0;
        this.dialog.crud.model = {
          bank: '',
          recipientId: '',
          accountName: '', accountNo: ''
        };
      }
      this.dialog.crud.show = true;
    },
    createBeneficiary() {
      this.$refs['form-bank-account'].validate(valid => {
        if (valid) {
          this.dialog.crud.isLoading = true;
          let model = this.dialog.crud.model;
          let [ bankId, bankName ] = model.bank.split(' - ');
          axios.post(
            `${process.env.VUE_APP_APIHOST}/gaa/acct/beneficiaries`,
            { 
              shopId: model.shopId,
              bankId, bankName,
              recipientId: model.recipientId,
              accountName: model.accountName, accountNo: model.accountNo
            }
          )
          .then(response => {
            this.$refs['list-beneficiaries'].loadData();
          })
          .catch(err => {
            console.error(`[BANK ACCOUNT] Cannot create new beneficiary`, err);
            this.$notify.error({
              title: '指令錯誤 - 無法新增',
              message: err.data.message
            });
          })
          .finally(() => {
            this.dialog.crud.show = false;
            this.dialog.crud.isLoading = false;
          });
        }
        else {
          return false;
        }
      });
    },
    updateBeneficiary() {
      this.$refs['form-bank-account'].validate(valid => {
        if (valid) {
          this.dialog.crud.isLoading = true;
          let model = this.dialog.crud.model;
          let [ bankId, bankName ] = model.bank.split(' - ');
          axios.put(
            `${process.env.VUE_APP_APIHOST}/gaa/acct/beneficiaries/${model.shopId}`,
            { 
              bankId, bankName,
              recipientId: model.recipientId,
              accountName: model.accountName, accountNo: model.accountNo
            }
          )
          .then(response => {
            this.$refs['list-beneficiaries'].loadData();
          })
          .catch(err => {
            console.error(`[BANK ACCOUNT] Cannot update beneficiary of ${model.shopId}`, err);
            this.$notify.error({
              title: '指令錯誤 - 無法更新',
              message: err.data.message
            });
          })
          .finally(() => {
            this.dialog.crud.show = false;
            this.dialog.crud.isLoading = false;
          });
        }
        else {
          return false;
        }
      });
    },
    deleteBeneficairy() {
      if (!confirm(`確定要刪除此帳戶？此動作無法復原。`)) return;
      this.dialog.crud.isLoading = true;
      axios.delete(
        `${process.env.VUE_APP_APIHOST}/gaa/acct/beneficiaries/${this.dialog.crud.model.shopId}`
      )
      .then(response => {
        this.$refs['list-beneficiaries'].loadData();
      })
      .catch(err => {
        console.error(`[BANK ACCOUNT] Cannot delete beneficiary of ${this.dialog.crud.model.shopId}`, err);
        this.$notify.error({
          title: '指令錯誤 - 無法刪除',
          message: err.data.message
        });
      })
      .finally(() => {
        this.dialog.crud.show = false;
        this.dialog.crud.isLoading = false;
      });
    },

    searchBank(qs, cb) {
      let banks = this.banks.map(bank => {
        return { value: `${bank['bank_id']} - ${bank['bank_name']}` };
      });
      let ret = qs? banks.filter(bank => bank.value.indexOf(qs) >= 0): banks;
      cb(ret);
    },
    searchShop(qs, cb) {

    },
    // updateSearch() {
    //   this.fetchBeneficiaries();
    // }
    
  },

  data() {
    return {
      isLoading: false,
      cols: [
        { key: 'account_id', label: '店家ID', width: 108, sortable: true },
        { key: 'shop_name', label: '店家' },
        { key: 'bank_id', label: '銀行', sortable: true },
        { key: 'recipient_id', label: '收款人ID／統編' },
        { key: 'account_name', label: '戶名' },
        { key: 'account_no', label: '帳號' },
        { key: 'actions', label: '修改', width: 96, align: 'center' }
      ],
      total: 0,
      searchKeyword: '',
      beneficiaries: [],
      banks: [],
      shops: [],
      
      
      queryParams: {
        startIndex: 0, limit: 10, search: '',
        sort: ''
      },

      dialog: {
        crud: {
          show: false,
          isLoading: false,
          mode: 'create',
          model: {
            shopId: 0,
            bank: '', recipientId: '',
            accountName: '', accountNo: ''
          },
          rules: {
            bank: [
              { required: true, message: '此欄位為必填！', trigger: 'change' }
            ],
            recipientId: [
              { required: true, message: '此欄位為必填！', trigger: 'change' }
            ],
            accountName: [
              { required: true, message: '此欄位為必填！', trigger: 'change' }
            ],
            accountNo: [
              { required: true, message: '此欄位為必填！', trigger: 'change' }
            ]
          }
        }
      }
    };
  },

  computed: {
    urlBeneficiaries() {
      return `${process.env.VUE_APP_APIHOST}/gaa/acct/beneficiaries`
    }
  }
}
</script>